var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import NoShowWidget from "./NoShowWidget";
var NoShowPaymentPage = function () {
    var token = useParams().token;
    if (!token) {
        return (_jsx(Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", p: 3 }, { children: _jsxs(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }, { children: [_jsx(ErrorIcon, { color: "error", sx: { fontSize: 50 } }), _jsx(Typography, __assign({ variant: "h6" }, { children: "No-show link is invalid or has expired." }))] })) })));
    }
    return (_jsx(Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", p: 3 }, { children: _jsx(NoShowWidget, { noShowToken: token }) })));
};
export default NoShowPaymentPage;
